import { BaseEntityModel } from '@/modules/core/app/models/abstracts/BaseEntityModel';

export class ClaraEscalationObject extends BaseEntityModel {
  branch?: string;
  reason?: string;
  evidence?: string;
  confidence?: string;
  createsTicket?: boolean;

  constructor(model: Partial<ClaraEscalationObject> = {}) {
    super(model);

    this.branch = model.branch;
    this.reason = model.reason;
    this.evidence = model.evidence;
    this.confidence = model.confidence;
    this.createsTicket = model.createsTicket ?? false;
  }
}
